import "./styles.less";

import React, { useEffect, useState } from "react";
import { FINCARAIZ_NEIGHBORHOODS_BY_CITY } from "./fincaraizNeighborhoods.config";

const VISIBLE_NEIGHBORHOODS_COUNT = 5;

const getCleanUrl = (url: string) => url.split(/[?#]/)[0];

const getRandomNeighborhoods = neighborhoods => {
	const items = [...neighborhoods];

	for (let i = items.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[items[i], items[j]] = [items[j], items[i]];
	}

	return items.slice(0, VISIBLE_NEIGHBORHOODS_COUNT);
};

const getVisibleNeighborhoodsByCity = (randomize = false) =>
	FINCARAIZ_NEIGHBORHOODS_BY_CITY.map(city => ({
		...city,
		neighborhoods:
			randomize && city.neighborhoods.length > VISIBLE_NEIGHBORHOODS_COUNT
				? getRandomNeighborhoods(city.neighborhoods)
				: city.neighborhoods.slice(0, VISIBLE_NEIGHBORHOODS_COUNT),
	}));

export const FincaraizNeighborhoodsSection: React.FC = () => {
	const [cities, setCities] = useState(getVisibleNeighborhoodsByCity);

	useEffect(() => {
		setCities(getVisibleNeighborhoodsByCity(true));
	}, []);

	return (
		<section className="fincaraiz-neighborhoods-section">
			<div className="fincaraiz-neighborhoods-section__container">
				<div className="fincaraiz-neighborhoods-section__header">
					<div className="fincaraiz-neighborhoods-section__header-text">
						<h2 className="fincaraiz-neighborhoods-section__title">
							Conoce los barrios de Colombia
						</h2>
						<p className="fincaraiz-neighborhoods-section__subtitle">
							Descubre las mejores zonas y localidades para arrendar, invertir o encontrar tu próximo hogar.
						</p>
					</div>
				</div>

				<div className="fincaraiz-neighborhoods-section__grid">
					{cities.map(city => {
						const cityUrl = getCleanUrl(city.cityUrl);

						return (
							<article className="fincaraiz-neighborhoods-section__card" key={city.city}>
								<a
									href={cityUrl}
									className="fincaraiz-neighborhoods-section__image-link"
									title={`Ver contenido de ${city.city}`}
								>
									<img
										src={city.image}
										alt={city.city}
										className="fincaraiz-neighborhoods-section__image"
										loading="lazy"
									/>
								</a>

								<h3 className="fincaraiz-neighborhoods-section__city">
									<a href={cityUrl} title={`Ver contenido de ${city.city}`}>
										{city.city}
									</a>
								</h3>

								<ul className="fincaraiz-neighborhoods-section__neighborhoods">
									{city.neighborhoods.map(neighborhood => (
										<li key={neighborhood.label}>
											<a href={getCleanUrl(neighborhood.url)}>
												{neighborhood.label}
											</a>
										</li>
									))}
								</ul>
							</article>
						);
					})}
				</div>
			</div>
		</section>
	);
};
